import { InvalidFormInfo, ValidFormInfo, RdReduxForm } from "rd-redux-forms";
import { AssetAttributeFormMeta } from "../adUnitAssetBuilderForm";
import { AssetFormSelectionResult } from "../selector/assetFormSelector";
import { AssetAttribute } from "store/api";

export function enumerateForms(assets: AssetFormSelectionResult): FormInfo[] {
    return [
        {
            data: assets.main.data,
            form: assets.main.form,
            meta: {
                assetPropertyName: "main",
                index: 0,
                formId: assets.main.form.id
            },
            assets: assets.main.assets
        } as FormInfo,
        ...assets.nested.reduce((arr, a) => {
            const newAssets = a.data.map<FormInfo>((data, index) => ({
                data: data.data,
                form: a.form,
                meta: {
                    formId: a.form.id,
                    index: index,
                    assetPropertyName: a.name
                },
                assets: a.assets
            }));

            return [...arr, ...newAssets];
        }, [])
    ];
}

export interface FormInfo {
    data: InvalidFormInfo<any> | ValidFormInfo<any>;
    form: RdReduxForm<any, AssetAttributeFormMeta>;
    meta: AssetAttributeFormMeta;
    assets: AssetAttribute[];
}
